module.exports = __webpack_public_path__ + "42189d6d210b82c36517d9f35a6cca46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Display/Components/Share/icons/facebook.jpg
// module id = 179
// module chunks = 6